










import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import { IClient } from "@/models/clients";
import { IInvoice } from "@/models/invoices";

@Component
export default class UCreditNoteLink extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public creditNoteId!: IInvoice["id"];

  @Prop({ required: false, default: undefined })
  public clientId?: IClient["id"];

  // Computed

  public get link() {
    if (this.isMockClientContext) return this.mockClientRouterLink();
    if (!this.isAdmin) return this.clientRouterLink();
    if (this.clientId) return this.adminRouterLink();
    return this.adminModalLink();
  }

  // Methods

  public mockClientRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: `admin__upmindCreditNote`,
          params: {
            invoiceId: this.creditNoteId
          }
        }
      }
    };
  }

  public clientRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: `clientCreditNote`,
          params: {
            invoiceId: this.creditNoteId
          }
        }
      }
    };
  }

  public adminRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: `adminCreditNote`,
          params: {
            clientId: this.clientId,
            invoiceId: this.creditNoteId
          }
        }
      }
    };
  }

  public adminModalLink() {
    return {
      type: "a",
      events: {
        click: () => {
          this.$store.dispatch(
            `data/${DataModules.INVOICES}/openCreditNotePreviewModal`,
            {
              creditNoteId: this.creditNoteId
            }
          );
        }
      }
    };
  }
}
